// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "." + chunkId + "." + "a76c4294101e2e2481c2" + ".chunk.js";
};